import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import { CheckListContext } from "../../utils/checkListContext";
import { useQuery } from "../../utils/useQuery";
import { usePost } from "../../utils/usePost";
import { useFetchChecklist } from "../../utils/useFetchChecklist";
import { usePostChecklistBE } from "../../utils/usePostChecklistBE";
import { API_BASE_URL, API_ROUTES } from "../../config";
import urlContain from "../../utils/urlContain";
import StepBar from "../../components/stepBar";
import AdminNewCheckQuestions from "./adminNewCheckQuestions";
import Swal from "sweetalert2";
import Loader from "../../components/Loader/Loader";
import { omit } from "lodash";
import { useRef } from "react";
import ModalWrapper from "../../components/previewModal";

const ProgressSteps = () => {
  const {
    errors,
    setErrors,
    totalQuestions,
    tempJSON,
    setTempJSON,
    setRating,
    ratingMetadata,
    checklistData,
    rating
  } = useContext(CheckListContext);

  let errorObj = errors;

  const [activeStep, setActiveStep] = useState(1);
  const [step, setStep] = useState([]);
  const [status, setStatus] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [imageName, setIMageName] = useState([]);
  const [post,setPost] = useState({});
  const [airtablePost, setAirtablePost] = useState({});
  const [confirmation,setConfirmation] = useState({});
  const ref = useRef(false);

  const queryParams = useQuery();
  //const lang = queryParams.get("lang");
  const product_id = queryParams.get("product_id");
  const userid = queryParams.get("userid");
  const product_Name = queryParams.get("product_name");
  const model_no = queryParams.get("model_no");
  const year = queryParams.get("year");

  const [data, fetchdata, fetching, statusBE] = useFetchChecklist(
    `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_ROUTE}${product_id}`
  );

  let fields = {
    tableName: "submission",
    fields: {
      User_ID: "",
      Response: "",
    },
  };

  const [postHandler, submitting, postError, success] = usePost();
  const [postData, postFn, submittingBE, postStatus] = usePostChecklistBE(
    `${API_BASE_URL.BASE_URL}${API_ROUTES.UPDATE_ROUTE}`
  );
  const [ratingPostData, ratingPostFn, ratingSubmittingBE, ratingPostStatus] = usePostChecklistBE(
    `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_RATING_CHECKLIST_QUESTIONS_ROUTE}`
  );

  useEffect(() => {
    statusBE && setRating(data?.data?.rating_scores);
    if(ref.current) return;
    if(postData){
      fetchdata();
      ref.current = true;
    }
  }, [data,postData]);

  useEffect(() => {
    let steps = step;
    let categoryNameArray = [];
    let stepId = 0;
    for (var i = 0; i < checklistData.length; i++) {
      if (!categoryNameArray.includes(checklistData[i].cat)) {
        steps = [...steps, { step: stepId + 1, label: checklistData[i].cat }];
        stepId++;
      }
      categoryNameArray = [...categoryNameArray, checklistData[i].cat];
    }
    setStep(steps);
  }, [checklistData]);

  useEffect(()=>{
  if(step?.length > 0){

  let confirmvar = confirmation;
  let filteredStep = step?.filter((catItem) => catItem.step === activeStep && catItem.label)
  let filteredQuestion = checklistData?.filter((item) => item?.cat === filteredStep?.[0]?.["label"] && item)
  let categoryName = filteredStep[0]["label"]?.split(' ')?.join('_');

  let total_not_okay = 0;
    for(var i = 0; i < filteredQuestion.length; i++){
      if(tempJSON[filteredQuestion[i]["id"]] === "not_ok" && !confirmvar.hasOwnProperty(categoryName)){
        total_not_okay = total_not_okay + 1;
        confirmvar = data?.data?.review_status ? {...confirmvar,[categoryName]:true,[`${categoryName}_total_not_okay`] : total_not_okay} : {...confirmvar,[categoryName]:false,[`${categoryName}_total_not_okay`] : total_not_okay};
      }else if(tempJSON[filteredQuestion[i]["id"]] === "not_ok" && confirmvar.hasOwnProperty(categoryName)){
        total_not_okay = total_not_okay + 1;
        confirmvar = {...confirmvar,[`${categoryName}_total_not_okay`] : total_not_okay};
      }
    }
    if(total_not_okay === 0){
      errorObj = omit(errorObj,categoryName);
      confirmvar = omit(confirmvar, `${categoryName}_total_not_okay`,categoryName)
    }
    setConfirmation(confirmvar);
  }
  },[step,tempJSON,activeStep])


  useEffect(() => {
    data?.data?.remarks !== "" && setRemarks(data?.data?.remarks);
    (data?.data?.images && data?.data?.images !== "") && setIMageName(data?.data?.images);
  }, [tempJSON]);

  // const handleRedirect = () => {
  //   window.location.href =
  //     window.location.href + "&submit.jotform.com/submit";
  // };
  useEffect(() => { 
    if(ratingPostStatus && ratingPostData){

      Swal.fire({
        html: `Star rating has been revised from ${rating?.baseline_score} star to ${ratingPostData?.data?.star_rating} star.`,
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonColor: "#652078",
        confirmButtonText: "Confirm & Submit",
        reverseButtons: true,
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {

        } else if (result.isConfirmed) {
          let postStatus = { ...post, review_status: true }
          //console.log("post",post,"airtablePost",airtablePost,postStatus)
          postFn(postStatus);
          postHandler(airtablePost);
          setStatus(true);
        }
      });
    }else if(!ratingPostStatus && ratingPostData){
      Swal.fire({
          icon: "error",
          text: ratingPostStatus?.data?.message
        }).then((res) => {
          if (res) {
          }
        });
    }
  },[ratingPostData])


  useEffect(() => {
    if(postStatus && ratingPostData){
      Swal.fire({
        icon: "success",
        confirmButtonColor: '#652078',
        text: `Successfully Submitted`
      }).then((res) => {
        if (res) {
          //window.close();
          //handleRedirect();
        }
      });
    }else if(!postStatus && ratingPostData){
      Swal.fire({
          icon: "error",
          text: postData?.data?.message
        }).then((res) => {
          if (res) {
          }
        });
    }

},[postData])

  const handleClickScroll = (quesID) => {
    const element = document.getElementById(quesID);
    if(element){
      element.scrollIntoView();
    }
  }

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setConfirmation((prevConfirmation) => ({
      ...prevConfirmation,
      [name]: checked
    }))
    errorObj = checked ? omit(errorObj,name) : errorObj
    setErrors(errorObj);
  }


  const nextStep = () => {
    let category = "";
    step?.filter((catItem) => {
      catItem.step === activeStep && (category = catItem.label)
    })
    if(!data?.data?.review_status){
      handleClickScroll(category.split(' ').join('_'))
      errorObj = (confirmation.hasOwnProperty(category.split(' ').join('_')) && confirmation[category.split(' ').join('_')]) ? omit(errorObj,category.split(' ').join('_')) :  {...errorObj, [category.split(' ').join('_')]: "Please select & confirm to move next."};
      setErrors(errorObj);
    }

  //   console.log("category",category,activeStep)
  //  let filteredQuestion = checklistData?.filter((item) => (item.cat === category))
  //  console.log("category1",category,filteredQuestion)
  //  let total_not_okay = 0;
  //   for(var i = 0; i < filteredQuestion.length; i++){
  //     if(tempJSON[filteredQuestion[i]["id"]] === "not_ok"){
  //       handleClickScroll(filteredQuestion[i]["id"])
  //       total_not_okay = total_not_okay + 1;
  //       confirmvar = !confirmvar.hasOwnProperty(category?.split(' ')?.join('_')) ? {...confirmvar,[category?.split(' ')?.join('_')]:false,[`${category?.split(' ')?.join('_')}_total_not_okay`] : total_not_okay} : confirmation;
  //       proceedNext = false;
  //     }else{
  //       proceedNext = true;
  //     }
  //   }
  //   console.log("confirmvar",confirmvar)
  //   setConfirmation(confirmvar);
  //   setIsProceedNext(proceedNext);
    // if(confirmation.hasOwnProperty(category.split(' ').join('_')) && !confirmation[category.split(' ').join('_')]){
    //   Swal.fire({
    //     html: "This is Not Okay<br/>" + "Are you sure you want to continue without changing?",
    //     icon: "question",
    //     showCancelButton: true,
    //     cancelButtonText: "Cancel",
    //     confirmButtonColor: "#652078",
    //     confirmButtonText: "Yes",
    //     reverseButtons: true,
    //   }).then((result) => {
    //     if (result.dismiss === Swal.DismissReason.cancel) {
    //       setIsProceedNext(false);
    //     } else if (result.isConfirmed) {
    //       setIsProceedNext(true);
    //       activeStep !== totalSteps && setActiveStep(activeStep + 1);
    //       (activeStep === totalSteps) && submitData();
    //     }
    //   });

    //   Swal.fire({
    //     icon: "success",
    //     confirmButtonColor: '#652078',
    //     text: `Please click on confirmation before continue to next.`
    //   }).then((res) => {
    //     if (res) {
    //       }
    //   });

    // }

    if(confirmation[category.split(' ').join('_')]){
      activeStep !== totalSteps && setActiveStep(activeStep + 1);
    }else if(!confirmation.hasOwnProperty(category.split(' ').join('_'))){
      activeStep !== totalSteps && setActiveStep(activeStep + 1);
    }
    if ((confirmation[category.split(' ').join('_')] || !confirmation.hasOwnProperty(category.split(' ').join('_'))) && activeStep === totalSteps) {
      submitData();
    }
  };

  const submitData = () => {
    if(!data?.data?.review_status){
      let tempJSONVar = tempJSON;
      tempJSONVar = { ...tempJSONVar, remarks: remarks, image: imageName };
      //console.log("tempJSONVar",tempJSONVar)
      fields = {
        tableName: "tech_submission",
        fields: {
          User_ID: userid,
          Response: JSON.stringify(tempJSONVar),
          Rating_Metadata: JSON.stringify(ratingMetadata),
          Product_Id: product_id,
          Product_Name: product_Name,
        },
      };
      let postBody = {
        user_id: userid,
        inventory_id: product_id,
        review_status: false,
        checklist: tempJSON,
        rating_metadata: ratingMetadata,
        remarks: remarks,
        images: imageName,
        approver_phone: 1234567889,
        product_name: product_Name,
        model_no: model_no,
        year: year,
        link_type: "Tech"
      };
      setAirtablePost(fields);
      setPost(postBody);
      setTempJSON(tempJSON);
      ratingPostFn(postBody);
    }else if(data?.data?.review_status){
      Swal.fire({
        icon: "info",
        confirmButtonColor: '#652078',
        text: `Already Submitted`
      }).then((res) => {
        if (res) {
          //window.close();
          //handleRedirect();
        }
      });
    }

    
  }

  const prevStep = () => {
    setActiveStep(activeStep - 1);
    setStatus(false);
  };
  const totalSteps = step.length;

  const width = `${(100 / (totalSteps - 1)) * (activeStep - 1)}%`;

  return (
    <StepBar>
      <StepBar.StepContainer width={width}>
        {step.map(
          ({ step, label }) =>
            label !== "" && (
              <StepBar.StepWrapper key={step}>
                <StepBar.StepStyle
                  step={activeStep >= step ? "completed" : "incomplete"}
                >
                  <StepBar.StepCount>{step}</StepBar.StepCount>
                </StepBar.StepStyle>
              </StepBar.StepWrapper>
            )
        )}
      </StepBar.StepContainer>
      {step.map(
        ({ step, label }) =>
          activeStep === step &&
          data.status && (
            <StepBar.StepContentContainer key={step.length + step}>
              <StepBar.StepTitleContainer>
                <StepBar.StepTitle>{label}</StepBar.StepTitle>
                <StepBar.CountText>
                  {totalQuestions[label]} Questions
                </StepBar.CountText>
              </StepBar.StepTitleContainer>
              <div>
                <AdminNewCheckQuestions
                  tableName={label}
                  status={status}
                  answeredData={data}
                  product_id={product_id}
                  userid={userid}
                />
              </div>              
              {activeStep === totalSteps && (
                <>
                  <br />
                  <Form.GroupFields>
                    <Form.Label>Remarks</Form.Label>
                    <Form.Textarea
                      cols="50"
                      rows="10"
                      disabled
                      onChange={(e) => setRemarks(e.target.value)}
                      value={remarks}
                    />
                  </Form.GroupFields>
                  <br />
                  <Form.GroupFields>
                    <Form.Label>Image Upload</Form.Label>
                    <Form.Input
                      type="file"
                      name="image_upload"
                      id="image_upload"
                      disabled
                      onChange={(e) => setIMageName(e.target.files[0].name)}
                    />
                  </Form.GroupFields>
                  {data?.data?.images?.length > 0 && (
                    <>
                      <p
                        style={{
                          textAlign: "center",
                          marginTop: "5px",
                          fontSize: "20px"
                        }}
                      >
                        <b>Uploaded Images</b>
                      </p>
                      <div
                        style={{
                          display: "flex",
                          overflow: "auto",
                          alignItems: "center",
                          gap: "5px"
                        }}
                      >
                        {data?.data?.images?.map((imageItem, index) => (
                          <div key={index}>
                            <img
                              src={urlContain(imageItem)}
                              alt=""
                              height="250"
                              width="250"
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  <br />
                </>
              )}
              {confirmation?.hasOwnProperty(label?.split(' ')?.join('_')) && <StepBar.GroupInput>
                <div style={{display:'flex'}}>
                <StepBar.CheckBox type="checkbox" name={label?.split(' ')?.join('_')} id={label?.split(' ')?.join('_')} checked={confirmation?.[label?.split(' ')?.join('_')]} onChange={(e) => handleCheckbox(e)} disabled={data?.data?.review_status} />
                <StepBar.Label htmlFor={label?.split(' ')?.join('_')} >There {confirmation[`${label.split(' ').join('_')}_total_not_okay`] > 1 ? "are" : "is"} <b>{confirmation[`${label.split(' ').join('_')}_total_not_okay`]} NOT OK</b>  are you sure want to continue without changing ?</StepBar.Label>
                </div>
                {errors?.hasOwnProperty(label?.split(' ')?.join('_')) && (
                    <p style={{ fontWeight:'700', color: "red", margin: "0px 2px 0px 10px" }}>
                      {errors[label?.split(' ')?.join('_')]}
                    </p>
                )}
              </StepBar.GroupInput>}
            </StepBar.StepContentContainer>
          )
      )}
      <div style={{ height: "50px" }}></div>
      <StepBar.ButtonsContainer>
        {activeStep !== 1 ? (
          <StepBar.ButtonStyle
            onClick={prevStep}
            disabled={status ? true : false}
          >
            Previous
          </StepBar.ButtonStyle>
        ) : (
          <div></div>
        )}
        <StepBar.ButtonStyle
          onClick={nextStep}
          disabled={status ? true : (activeStep === totalSteps && data?.data?.review_status) ? true : false}
        >
          {(activeStep === totalSteps && data?.data?.review_status) ? "Tech Head Review Done" : (activeStep === totalSteps) ? "Generate Star Rating" : "Next"}
        </StepBar.ButtonStyle>
      </StepBar.ButtonsContainer>
      { (submittingBE || ratingSubmittingBE) && <ModalWrapper><Loader /></ModalWrapper> }
    </StepBar>
  );
};

export default ProgressSteps;